// AI Generated Component
import { Component, Input, OnChanges } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { QAReadabilityService } from '@client/app/blocks/service/qa-readability/qareadability.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import {
    ReadabilityPagesWithScoreComponent,
} from '@client/app/pages/qa/readability/summary/pages-with-score/pages-with-score.component';

@Component({
    selector: 'readability-summary-score',
    standalone: false,
    template: `
        <div class="row">
            <div class="col-48">
                <table-container [collection]="readabilityScores" [noResultMessage]="'No readability score' | translate">
                    <table class="table table-hover table-fixed">
                        <thead>
                            <tr>
                                <th class="col-24 col-md-40">&nbsp;</th>
                                <th class="col-24 col-md-8 text-right" translate>
                                    <span class="mr-2">Pages</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let level of readabilityScores; let i = index">
                                <td class="text-v-middle">
                                    <span class="pl-2">{{ level.name | translateReadability:summary.test }}</span>
                                    <span class="fas fa-question-circle"
                                          *ngIf="hasTooltipDescription(level)"
                                          [triggers]="'focus hover'"
                                          [tooltipClass]="'tooltip-text-left tooltip-text-long'"
                                          [ngbTooltip]="getTooltipDescription(level)">
                                    </span>
                                    <span class="ml-1 text-grey" *ngIf="isHighestPageCount(i)">
                                        <span class="fas fa-exclamation-circle outer-r-smurf"></span>
                                        <span translate>Most pages have this readability level</span>
                                    </span>
                                </td>
                                <td class="text-right">
                                    <pages-button
                                            (callback)="openPages(level.name)"
                                            [text]="'Pages' | translate"
                                            [(ngModel)]="level.page_count"
                                            name="level-page-count-{{i}}">
                                    </pages-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </table-container>
            </div>
        </div>
    `,
})
export class ReadabilitySummaryScoreComponent implements OnChanges {
    @Input() summary: any;
    @Input() totalPageCount: any;
    @Input() filterType: any;

    readabilityScores: any;
    highestPageCountIndex: any;

    constructor (
        private monEventService: MonEventService,
        private qaReadabilityService: QAReadabilityService,
    ) {}

    ngOnChanges () {
        this.readabilityScores = this.qaReadabilityService.sortReadability(this.summary.test, this.summary.distribution);
        this.highestPageCountIndex = this.readabilityScores.reduce((highestIndex: any, distribution: any, index: any) => {
            if (this.readabilityScores[highestIndex].page_count < distribution.page_count) {
                return index;
            }
            return highestIndex;
        }, 0);
        this.readabilityScores.total = this.readabilityScores.length;
    }

    isHighestPageCount (index: any) {
        return this.highestPageCountIndex === index;
    }

    openPages (score: any) {
        const params = {
            body: ReadabilityPagesWithScoreComponent,
            size: 'lg',
            data: {
                score: score,
                totalPageCount: this.totalPageCount,
                filterType: this.filterType,
            },
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    hasTooltipDescription (level: any) {
        return this.qaReadabilityService.hasTooltipScore(level.name, this.summary.test);
    }

    getTooltipDescription (level: any) {
        return this.qaReadabilityService.getTooltipScore(level.name, this.summary.test);
    }
}
